import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper/bundle'

// Connects to data-controller="swiper"
export default class extends Controller {

  static values = {
    config: String
  }

  connect() {
    const swiperConfig = this.getSwiperConfig();
    this.swiper = new Swiper(this.element, swiperConfig);
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  }

  getSwiperConfig() {
    const configName = this.configValue || "default";

    const baseConfig = {
      slidesPerView: 1.5,
      autoHeight: true,
      spaceBetween: 24,
      loop: false,
      watchSlidesProgress: true,
      navigation: {
        enabled: true,
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next",
      },
      pagination: {
        enabled: true,
        clickable: true,
        el: ".swiper-pagination"
      },
      lazy: { enabled: true },
      breakpointsBase: 'window'
    }


    const configurations = {
      default: {
        ...baseConfig,
        breakpoints: {
          768: { slidesPerView: 2 },
          1200: { slidesPerView: 3 }
        }
      },

      configHero: {
        ...baseConfig,
        slidesPerView: 1,
        loop: true,
        speed: 800,
        autoplay: { enabled: true, pauseOnMouseEnter: true, delay: 2000 },
        navigation: { enabled: false }
      },

      configCol4: {
        ...baseConfig,
        navigation: {
          enabled: false,
        },
        breakpoints: {
          768: { slidesPerView: 2 },
          992: { slidesPerView: 3 },
          1200: { slidesPerView: 4 }
        }
      }
    }

    return configurations[configName] || configurations.default;

  }
}
